let IS_PROD = true;
const server = IS_PROD ?
    "https://babu-poojary-zoom-demo-backend.onrender.com" :

    "http://localhost:8000"


export default server;